import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Container, Row, Col, Badge, Spinner } from 'react-bootstrap';
import Swal from "sweetalert2";
import axiosInstance from "../../../services/AxiosInstance";




const ShowScore = () => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let id = params.get('id');

  const [score, setScore] = useState(0);
  const [isShowScore, setIsShowScore] = useState(false);
  const navigate = useNavigate();

  const goToList = () => {
    navigate('/ujian/list');
  }

  useEffect(() => {
    console.log('show score id', id);
    if(id != null){
      loadUjianDetail();
    }
}, [id])

  const loadUjianDetail = async () => {
    try {
      const res = await axiosInstance.get(`test-online/siswa/ujian/${id}`);
      console.log(res);
      var dataUjian = res.data.data;
      console.log("ShowScore : ", dataUjian);
      setIsShowScore(dataUjian.is_show_score);
      if (dataUjian.is_show_score) {
        setScore(dataUjian.nilai_bobot);
      } else {
        navigate('/ujian/list');
      }
    } catch (error) {
      console.log(error);
      if (error.code == "ERR_BAD_REQUEST") {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `${error.response.data.message}`,
          willClose: () => {
            navigate('/ujian/list');
          }
        })
      }
    }
  }

  if (!isShowScore) {
    return (
      <Container className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="text-center">
          <h5 className="mb-3">Anda akan dialihkan...</h5>
          <Spinner animation="border" variant="primary" />
        </div>
      </Container>
    );
  }

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <Card className="text-center shadow-lg p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <Card.Body>
          <Card.Title className="mb-2" style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
            Hasil Ujian
          </Card.Title>
          <Card.Text className="text-muted mb-4">Hasil ujian:</Card.Text>

          <div
            className={`rounded-circle mx-auto mb-4 d-flex justify-content-center align-items-center`}
            style={{
              width: '140px',
              height: '140px',
              color: 'black',
              fontSize: '3rem',
              fontWeight: 'bold',
            }}
          >
            {score}
          </div>

          <Button
            variant="primary"
            className="mt-4 px-4"
            onClick={() => goToList()}
          >
            Daftar Ujian
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ShowScore;
